export default __webpack_public_path__ + "static/media/createFBPage.13848cec.png";